import { apiService } from '../core/api.service';
import environment from 'src/settings/environmentLoader';
import SubscriptionPlan from 'src/models/SubscriptionPlan';

export namespace SubscriptionService {

    export async function getSubscriptionPlan() {

        if (!environment.features.subscriptions) {
            let subscriptionPlan: SubscriptionPlan = {
                userId: "",
                subscriptionId: "dev-subscription",
                plan: "LIFETIME",
                startDate: new Date(),
                endDate: new Date("2999-12-31 T23:59:59Z"),
                status: "ACTIVE",
                daysLeft: 3650,
                source: "NONE"
            };
            return subscriptionPlan;
        }

        try {
            return await apiService.get<SubscriptionPlan>('/subscriptions/get-subscription');
        } catch (error) {
            throw error; // Re-throw the standardized error from apiService
        }
    }

    export async function importAwsSubscription(accountId: string, productCode?: string) {
        // The productCode is required to handle cases where a customer has multiple purchases
        // (e.g., upgrading from monthly subscription to lifetime license).
        // If not provided, backend will attempt to look it up from the Customers table.

        try {
            const body: { accountId: string; productCode?: string } = {
                accountId: accountId
            };

            if (productCode) {
                body.productCode = productCode;
            }

            return await apiService.post('/subscriptions/aws-import-subscription', {
                body: body
            });
        } catch (error) {
            throw error; // Re-throw the standardized error from apiService
        }
    }
}